export function transformSearchItemToCategoryItem (itemGroup, instantSearchInstance) {
  const {
    'items.condition': filteredCondition = [],
    'items.packaging': filteredPackaging = [],
  } = instantSearchInstance.helper.state.disjunctiveFacetsRefinements;

  const matchingItems = itemGroup.items.find(({ condition, packaging }) => (
    (!filteredCondition.length || filteredCondition.some((value) => condition.includes(value))) &&
    (!filteredPackaging.length || filteredPackaging.some((value) => packaging.includes(value)))
  ));
  const primaryItem = matchingItems[0] || itemGroup.items[0];
  const priceFormatted = itemGroup.reference_price.toFixed(2).replace(/\.(\d{2})$/, ',$1') + " €";
  const suffix = /-modul$/.test(itemGroup.id)
    ? " (Modul)"
    : /-mit-ovp/.test(itemGroup.id)
      ? " (mit OVP)"
      : '';

  return {
    item: {
      id: primaryItem.item_id,
      barcodes: [],
      defaultCategories: [],
      free1: "", //! TODO
      free2: "", //! TODO
      free3: "", //! TODO
      free4: "", //! TODO
      free5: "", //! TODO
      free6: "", //! TODO
      free7: "", //! TODO
      free8: "", //! TODO
      free9: "", //! TODO
      free10: "", //! TODO
      free11: "", //! TODO
      free12: "", //! TODO
      free13: "", //! TODO
      free14: "", //! TODO
      free15: "", //! TODO
      free16: "", //! TODO
      free17: "", //! TODO
      free18: "", //! TODO
      free19: "", //! TODO
      free20: "", //! TODO
      producingCountryId: 1,
      customsTariffNumber: "",
      itemType: "default",
      condition: { //! TODO
        "id": 1,
        "names": {
          "lang": "de",
          "name": "Gebraucht"
        }
      },
      conditionApi: { //! TODO
        "id": 3,
        "names": {
          "lang": "de",
          "name": "Gebraucht gut"
        }
      },
      revenueAccount: 0,
      ageRestriction: 6, //! TODO
      add_cms_page: "0",
      manufacturerId: 0,
      storeSpecial: null,
      producingCountry: {
        names: {
          "name": "Deutschland",
          "lang": "de"
        },
        id: 1,
        lang: "de",
        name: "Deutschland",
        active: 1,
        storehouseId: 1,
        isCountryStateMandatory: null,
        isoCode2: "DE",
        shippingDestinationId: 6,
        isoCode3: "DEU"
      },
      manufacturer: [],
      rebate: 0,
      salableVariationCount: 1,
      unit: {
        names: {
          unitId: 1,
          lang: "de",
          name: "Stück"
        },
        unitOfMeasurement: "C62",
        content: 1
      },
      hasOrderProperties: false,
      hasRequiredOrderProperty: false,
    },
    variation: { //! TODO
      id: primaryItem.variation_id,
      position: primaryItem.sales_rank,
      number: "NEW-13433",
      model: "",
      externalId: "",
      availabilityId: primaryItem.availability_id,
      maximumOrderQuantity: null,
      minimumOrderQuantity: 1,
      intervalOrderQuantity: 1,
      availableUntil: null,
      releasedAt: null,
      name: "",
      weightG: 0,
      weightNetG: 0,
      widthMM: 0,
      lengthMM: 0,
      heightMM: 0,
      unitsContained: 1,
      bundleType: null,
      mayShowUnitPrice: false,
      availabilityUpdatedAt: "2019-06-26T07:25:30+02:00",
      availability: {
        id: primaryItem.availability_id,
        icon: `av${primaryItem.availability_id}.gif`,
        averageDays: 0,
        createdAt: "2019-08-07 11:02:02",
        updatedAt: "2019-08-07 11:02:02",
        names: {
          id: 33,
          availabilityId: primaryItem.availability_id,
          lang: "de",
          name: primaryItem.availability,
          createdAt: "2021-04-26 11:57:46",
          updatedAt: "2021-04-26 11:57:46"
        },
        iconPath: `/tpl/availability/av${primaryItem.availability_id}.gif`,
        mappedAvailability: "https://schema.org/" + primaryItem.availability === 5 ? "OutOfStock" : "InStock"
      },
      unitCombinationId: 1
    },
    filter: {
      hasManufacturer: false,
      isSalable: primaryItem.availability_id !== 5,
      isSalableAndActive: true,
      hasActiveChildren: false,
      isMultiItem: itemGroup.items.length > 1,
    },
    texts: {
      itemId: primaryItem.item_id,
      technicalData: "",
      lang: "de",
      name1: itemGroup.name,
      name2: itemGroup.short_name,
      name3: itemGroup.system ?? itemGroup['category.lvl1'][0] ?? "",
      title: itemGroup.name,
      description: itemGroup.description,
      metaDescription: "",
      urlPath: primaryItem.url_path,
      shortDescription: "",
      keywords: ""
    },
    images: {
      all: [ //! TODO
        {
          "names": [],
          "path": "",
          "url": itemGroup.cover_image,
          "urlMiddle": itemGroup.cover_image,
          "urlSecondPreview": itemGroup.cover_image_thumbnail,
          "position": 0,
          "urlPreview": itemGroup.cover_image_thumbnail,
          "cleanImageName": ""
        }
      ],
      variation: []
    },
    prices: {
      default: {
        price: {
          value: itemGroup.reference_price,
          formatted: priceFormatted
        },
        unitPrice: {
          value: itemGroup.reference_price,
          formatted: priceFormatted
        },
        basePrice: "N / A",
        baseLot: null,
        baseUnit: null,
        baseSinglePrice: null,
        minimumOrderQuantity: 1,
        contactClassDiscount: {
          percent: 0,
          amount: 0
        },
        categoryDiscount: {
          percent: 0,
          amount: 0
        },
        currency: "EUR",
        lowestPrice: {
          value: null,
          formatted: ""
        },
        vat: {
          id: 2,
          value: 0
        },
        isNet: false,
        data: {
          salesPriceId: 1,
          price: itemGroup.reference_price,
          priceNet: itemGroup.reference_price,
          basePrice: itemGroup.reference_price,
          basePriceNet: itemGroup.reference_price,
          unitPrice: itemGroup.reference_price,
          unitPriceNet: itemGroup.reference_price,
          lowestPrice: null,
          lowestPriceNet: null,
          customerClassDiscountPercent: 0,
          customerClassDiscount: 0,
          customerClassDiscountNet: 0,
          categoryDiscountPercent: 0,
          categoryDiscount: 0,
          categoryDiscountNet: 0,
          vatId: 2,
          vatValue: 0,
          currency: "EUR",
          interval: "none",
          conversionFactor: 1,
          minimumOrderQuantity: "1.00",
          updatedAt: new Date(itemGroup.timestamp).toISOString(),
          type: "default",
          pricePosition: 0
        }
      },
      rrp: {
        price: {
          value: itemGroup.reference_rrp,
          formatted: itemGroup.reference_rrp.toFixed(2).replace(/\.(\d{2})$/, ',$1') + " €"
        },
        unitPrice: {
          value: itemGroup.reference_rrp,
          formatted: itemGroup.reference_rrp.toFixed(2).replace(/\.(\d{2})$/, ',$1') + " €"
        },
        basePrice: "",
        baseLot: null,
        baseUnit: null,
        baseSinglePrice: null,
        minimumOrderQuantity: 0,
        contactClassDiscount: {
          percent: 0,
          amount: 0
        },
        categoryDiscount: {
          percent: 0,
          amount: 0
        },
        currency: "EUR",
        lowestPrice: {
          value: null,
          formatted: ""
        },
        vat: {
          id: 2,
          value: 0
        },
        isNet: false,
        data: {
          salesPriceId: 34,
          price: itemGroup.reference_price,
          priceNet: itemGroup.reference_price,
          basePrice: itemGroup.reference_price,
          basePriceNet: itemGroup.reference_price,
          unitPrice: itemGroup.reference_price,
          unitPriceNet: itemGroup.reference_price,
          lowestPrice: null,
          lowestPriceNet: null,
          customerClassDiscountPercent: 0,
          customerClassDiscount: 0,
          customerClassDiscountNet: 0,
          categoryDiscountPercent: 0,
          categoryDiscount: 0,
          categoryDiscountNet: 0,
          vatId: 2,
          vatValue: 0,
          currency: "EUR",
          interval: "none",
          conversionFactor: 1,
          minimumOrderQuantity: "0.00",
          updatedAt: new Date(itemGroup.timestamp).toISOString(),
          type: "rrp",
          pricePosition: 13
        }
      },
      set: null,
      specialOffer: null,
      graduatedPrices: [
        {
          price: {
            value: itemGroup.reference_price,
            formatted: priceFormatted
          },
          unitPrice: {
            value: itemGroup.reference_price,
            formatted: priceFormatted
          },
          basePrice: "",
          baseLot: null,
          baseUnit: null,
          baseSinglePrice: null,
          minimumOrderQuantity: 1,
          contactClassDiscount: {
            percent: 0,
            amount: 0
          },
          categoryDiscount: {
            percent: 0,
            amount: 0
          },
          currency: "EUR",
          lowestPrice: {
            value: null,
            formatted: ""
          },
          vat: {
            id: 2,
            value: 0
          },
          isNet: false,
          data: {
            salesPriceId: 1,
            price: itemGroup.reference_price,
            priceNet: itemGroup.reference_price,
            basePrice: itemGroup.reference_price,
            basePriceNet: itemGroup.reference_price,
            unitPrice: itemGroup.reference_price,
            unitPriceNet: itemGroup.reference_price,
            lowestPrice: null,
            lowestPriceNet: null,
            customerClassDiscountPercent: 0,
            customerClassDiscount: 0,
            customerClassDiscountNet: 0,
            categoryDiscountPercent: 0,
            categoryDiscount: 0,
            categoryDiscountNet: 0,
            vatId: 2,
            vatValue: 0,
            currency: "EUR",
            interval: "none",
            conversionFactor: 1,
            minimumOrderQuantity: "1.00",
            updatedAt: new Date(itemGroup.timestamp).toISOString(),
            type: "default",
            pricePosition: 0
          }
        }
      ]
    },
    properties: [],
    facets: [],
    attributes: []
  }
}